import { FunctionComponent, memo } from "react";

import { LoadingSkeleton, None, NumericValue } from "@edgetier/client-components";
import { IProps } from "./interaction-metric-summary-percentage-value.types";
import "./interaction-metric-summary-percentage-value.scss";

/**
 * Format and display an interaction metric summary percentage value.
 * @param props.isMaybeLoading    When true, some agent data may still be loading.
 * @param props.value             The metric summary value.
 */
const InteractionMetricSummaryPercentageValue: FunctionComponent<IProps> = ({ isMaybeLoading, value }) => {
    return (
        <>
            {isMaybeLoading && (typeof value === "undefined" || value === null) ? (
                <LoadingSkeleton width={50} containerTestId="interaction-metric-summary-percentage-value__loading" />
            ) : typeof value === "undefined" || value === null ? (
                <None>N/A</None>
            ) : (
                <NumericValue value={value} options={{ maximumFractionDigits: 1 }} unit="%" />
            )}
        </>
    );
};

export default memo(InteractionMetricSummaryPercentageValue);
